import * as yup from 'yup'

export const schemaChangeUserRoles = yup.object().shape({
  roles: yup.array().of(
    yup.object().shape({
      id: yup.number(),
    }),
  ),
})
